import { Fab, FabProps, KeyboardArrowUpIcon, makeStyles } from '@freighthub/silhouette-core'
import { FC } from 'react'

const useStyles = makeStyles({
  fab: {
    position: 'fixed',
    bottom: 20,
    right: 100,
    zIndex: 1000,
  },
})

interface ScrollToTopProps extends Partial<FabProps> {}

export const ScrollToTop: FC<ScrollToTopProps> = (props) => {
  const classes = useStyles()
  return (
    <Fab color="primary" className={classes.fab} {...props}>
      <KeyboardArrowUpIcon />
    </Fab>
  )
}
